import React from 'react';
import InfoField from './InfoField';

const OptionalInfoField = ({ children, ...rest}) => 
  children ? <InfoField {...rest}>{children}</InfoField> : < ></>;

export default OptionalInfoField;